import { create } from 'zustand';

import { SelectOptionProps } from '@/types';

export const useFilterStore = create<{
  organizationFilter: SelectOptionProps | null;
  setOrganizationFilter: (value: SelectOptionProps | null) => void;
}>((set) => ({
  organizationFilter: null,
  setOrganizationFilter: (value) => set({ organizationFilter: value })
}));
